// src/pages/Hosts.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; 
import HostList from './parts/HostList';
import OrganisationManagement from '../components/OrganisationManagement';
import AddOrganisation from '../components/widgets/AddOrganisation'; 
import ImportOrganisationWidget from '../components/widgets/ImportOrganisationWidget'; 
import './style/PageStyle/Hosts.css';

const Hosts = () => {
  const navigate = useNavigate(); 
  const [selectedOrganisation, setSelectedOrganisation] = useState(null);
  const [showManageWidget, setShowManageWidget] = useState(false);
  const [showAddWidget, setShowAddWidget] = useState(false); 
  const [showImportWidget, setShowImportWidget] = useState(false);
  
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const handleOrganisationSelect = (Organisation) => {
    setSelectedOrganisation(Organisation);
  };

  const handleSaveOrganisation = (updatedOrg) => {
    console.log('Updated Organisation:', updatedOrg);
    setSelectedOrganisation(updatedOrg);
    setShowManageWidget(false);
    setRefreshTrigger(prev => prev + 1); 
  };

  const handleCreateOrganisation = () => {
      console.log('Organisation created, refreshing list...');
      setShowAddWidget(false);
      setRefreshTrigger(prev => prev + 1); 
  };

  const handleImportSuccess = () => {
    setShowImportWidget(false);
    setRefreshTrigger(prev => prev + 1);
  };

  const handleClosePanel = () => {
    setSelectedOrganisation(null);
  };

  const handleDeleteOrganisation = async (orgId) => {
    if(!window.confirm("Are you sure you want to delete this organisation?")) return;

    try {
      // await apiService.deleteOrganisation(orgId); 
      setShowManageWidget(false);
      setSelectedOrganisation(null);
      setRefreshTrigger(prev => prev + 1); 
    } catch (error) {
      console.error("Failed to delete", error);
      alert("Failed to delete organisation.");
    }
  };

  // --- NEW HANDLER: Navigate to Documents with Filter ---
  const handleViewDocuments = () => {
    if (selectedOrganisation) {
      navigate('/documents', {
        state: {
          filters: {
            organisation: selectedOrganisation.name // Passing the name to pre-fill the filter
          }
        }
      });
    }
  };

  return (
    <div className="hosts">
      {/* CLEANED HEADER SECTION */}
      <div className="hosts-header">
        <div>
          <h1>Organisation Management</h1>
          <p>Manage and monitor Organisations in the system</p>
        </div>
        
        <div className="header-actions">
          <button 
            className="btn-secondary" 
            onClick={() => setShowImportWidget(true)}
          >
           📥 Import CSV
          </button>
          <button 
            className="btn-primary-add-org" 
            onClick={() => setShowAddWidget(true)}
          >
            + Add Organisation
          </button>
        </div>
      </div>

      <div className="Organisations-main">
        <HostList 
          key={refreshTrigger} 
          onOrganisationSelect={handleOrganisationSelect}
          selectedOrganisation={selectedOrganisation}
        />
      </div>

      {selectedOrganisation && (
        <div className="Organisation-details-panel">
          <div className="panel-header">
            <h3>Organisation Details</h3>
            <button className="close-panel-btn" onClick={handleClosePanel}>&times;</button>
          </div>

          <div className="org-detail-section">
            {/* --- NEW FIELD: Organisation ID --- */}
            <div className="detail-row">
              <span className="detail-label">ID:</span>
              <span className="detail-value" style={{ fontWeight: 'bold', color: '#64748b' }}>
                {selectedOrganisation.custom_id || '-'}
              </span>
            </div>

            <div className="detail-row">
              <span className="detail-label">Organisation:</span>
              <span className="detail-value">{selectedOrganisation.name}</span>
            </div>
            
            <div className="detail-row">
              <span className="detail-label">Type:</span>
              <span className="detail-value">{selectedOrganisation.type || 'N/A'}</span>
            </div>


            <div className="detail-row">
              <span className="detail-label">Rebate %:</span>
              <span className="detail-value">{selectedOrganisation.rebate ? `${selectedOrganisation.rebate}%` : 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Redistribution %:</span>
              <span className="detail-value">{selectedOrganisation.redistribution ? `${selectedOrganisation.redistribution}%` : 'N/A'}</span>
            </div>
  

            <div className="detail-row">
              <span className="detail-label">Users:</span>
              <span className="detail-value">{selectedOrganisation.userCount || 0} active users</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Documents:</span>
              <span className="detail-value">{selectedOrganisation.documentCount || 0} documents</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Contact:</span>
              <span className="detail-value">{selectedOrganisation.contactEmail || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Location:</span>
              <span className="detail-value">{selectedOrganisation.location}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Description:</span>
              <span className="detail-value">{selectedOrganisation.description || 'No description'}</span>
            </div>
            
            <div className="org-actions">
              <button 
                className="btn-primary"
                onClick={() => setShowManageWidget(true)}
              >
                Manage Organisation & Users
              </button>
              
              <button 
                className="btn-secondary"
                onClick={handleViewDocuments} 
              >
                View Documents
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Management Widget */}
      {showManageWidget && selectedOrganisation && (
        <OrganisationManagement 
          organisation={selectedOrganisation}
          onClose={() => setShowManageWidget(false)}
          onSave={handleSaveOrganisation}
          onDelete={handleDeleteOrganisation} 
        />
      )}

      {/* Add Organisation Widget */}
      {showAddWidget && (
        <AddOrganisation 
          onClose={() => setShowAddWidget(false)}
          onSave={handleCreateOrganisation}
        />
      )}

      {/* Import Organisation Widget */}
      {showImportWidget && (
        <ImportOrganisationWidget 
          onClose={() => setShowImportWidget(false)}
          onSave={handleImportSuccess}
        />
      )}
    </div>
  );
};

export default Hosts;
